import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';

import { EOrderStatus } from '@/types/orders';

import { DangerIcon } from '@/shared/ui/icons';
import { getTimeWithGMTKz } from '@/shared/utils/get-time-with-gmt';

import * as Styled from './styled';

type TProps = {
    orderStatusTime: string;
    status: EOrderStatus;
    t: (key: string, values?: unknown) => string;
};

export const useShowWarnByActiveStatus = ({ orderStatusTime, status, t }: TProps): FC => {
    const [isShowWarnByActiveStatus, setIsShow] = useState<boolean>(false);

    useEffect(() => {
        if (dayjs(getTimeWithGMTKz()).diff(dayjs(orderStatusTime), 'minutes') > 20) {
            setIsShow(true);
        }
    }, []);

    return function WarningStatusComponent() {
        return (
            <>
                {status === EOrderStatus.Active && isShowWarnByActiveStatus && (
                    <Styled.Wrapper className="info">
                        <DangerIcon width={40} />
                        <Styled.Text>
                            <span>{t('Эта заявка обрабатывается уже больше 20 минут, что довольно необычно 🤔.')}</span>
                            <span>
                                {t('Вы можете подождать еще или сразу написать нам в чат, мы во всем разберемся')}
                            </span>
                        </Styled.Text>
                    </Styled.Wrapper>
                )}
            </>
        );
    };
};
